<template>
    <!-- popup thêm nhanh khách hàng -->
	<div>
		 <!-- popup -->
		<el-dialog custom-class="n-modal" title="Thêm mới khách hàng" :before-close="closeDialog" :visible.sync="show" width="440px"
			@close="resetForm('ruleForm')">
			<!-- body -->
			<el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
				class="demo-ruleForm">
				<el-form-item label="Họ và tên" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="Số điện thoại" prop="phone">
					<el-input v-model="ruleForm.phone"></el-input>
				</el-form-item>
			</el-form>
			<!-- footer -->
			<div slot="footer">
				<el-button class="n-btn" @click="resetForm('ruleForm'); closeDialog();">Huỷ</el-button>
				<el-button class="n-btn" type="primary" @click="submitFormAddCustomer('ruleForm')">Hoàn tất</el-button>
			</div>
		</el-dialog>

		<!-- loading -->
		<div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
	</div>
</template>

<script>
import { CustomerServices } from '@/services/nextshop/customer.service'

export default {
  props: ["listCustomer","show"],
  data() {
    var checkDup = (rule, value, callback) => {
			setTimeout(() => {
				const listPhone = this.listCustomer.map(e => e.phoneNo)
				if (listPhone.includes(value)) {
					callback(new Error('Số điện thoại bị trùng. Xin hãy nhập lại'));
				} else {
					callback();
				}
			}, 1000);
		};
    return {
      ruleForm: {
				name: '',
				phone: ''
			},
			rules: {
				name: [
					{ required: true, message: 'Họ và tên không được để trống', trigger: 'blur' },
					{ min: 1, max: 255, message: 'Họ và tên không quá 255 ký tự', trigger: 'blur' }
				],
				phone: [
					{ required: true, message: 'Số điện thoại không được để trống', trigger: 'blur' },
					{ pattern: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/, message: 'Số điện thoại không hợp lệ', trigger: 'blur' },
					{ min: 1, max: 15, message: 'Số điện thoại không quá 15 kí tự', trigger: 'blur' },
					{ validator: checkDup, trigger: 'blur' }
				]
			},
			coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
			loading: false,
    }
  },
  methods: {
    resetForm(addCustomerForm) {
			this.$refs[addCustomerForm].resetFields();
		},
    submitFormAddCustomer() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					this.quickAddCustomer()
				} else {
					return false;
				}
			});
		},
    closeDialog() {
			this.$emit("close")
    },
    async quickAddCustomer() {
			this.loading = true
			try {
				const params = {
					name: this.ruleForm.name,
					phoneNo: this.ruleForm.phone,
					person: true,
					merchantId: this.coMerchantId
				}
				const data = await CustomerServices.createCustomer(params)
				if (data.success) {
					if (data.code == 'SUCCESSFUL') {
						const cusInfo = {
							...data.data,
							text: data.data.name + " - " + data.data.phoneNo
						}
						// this.listCustomer.push(cusInfo)
						// this.order.partyB.resId = cusInfo.id
						// this.setMutationItemPos(this.dataItem)
            this.$emit("addCustomerDone", cusInfo)
					}
				}

			} catch (error) {
				console.log(error);
			} finally {
				this.loading = false
			}
		},

  }
}
</script>

<style lang="scss">
.demo-ruleForm {
	.el-form-item__label {
		padding-bottom: 0;
		margin-bottom: 0;
	}
}
</style>